import React, { useState } from "react";
import Modal, { modalStyles as m } from "./Modal";
import { ToastifyAlert } from "../../../CommonComponents/ToastifyAlert";

// Android setOpenHoldBasketDialog (DialogHoldBasketBinding) + isHoldBasketValidView: holding a sale
// asks for a BASKET NAME (required) and a mobile number (OPTIONAL — but when entered it must be
// exactly 10 digits; the field is inputType=number, maxLength=phone_number_length=10). Both are
// prefilled from the attached customer. The basket name is what the Held list shows.
export default function HoldBasketModal({ customer, onProceed, onClose }) {
  const c = customer || {};
  const first = String(c.f_name ?? c.firstName ?? c.first_name ?? "").trim();
  const last = String(c.l_name ?? c.lastName ?? c.last_name ?? "").trim();
  const prefilled = (last ? `${first} ${last}` : first).trim() || String(c._name ?? c.name ?? "").trim();
  const [name, setName] = useState(prefilled);
  const [mobile, setMobile] = useState(String(c.phone ?? c.mobile ?? c.phone_no ?? "").replace(/\D/g, "").slice(0, 10));

  const proceed = () => {
    const n = name.trim();
    const mob = mobile.trim();
    if (!n) return ToastifyAlert("Enter basket name", "error");
    if (mob && !/^\d{10}$/.test(mob)) return ToastifyAlert("Enter valid mobile number", "error");
    onProceed({ basketName: n, mobile: mob });
  };

  return (
    <Modal title="Hold basket" onClose={onClose}>
      <div style={m.label}>Basket name</div>
      <input style={m.input} autoFocus value={name} onChange={(e) => setName(e.target.value)} placeholder="Basket name" onKeyDown={(e) => e.key === "Enter" && proceed()} />
      <div style={{ ...m.label, marginTop: 12 }}>Mobile number (optional)</div>
      <input
        style={m.input}
        inputMode="numeric"
        maxLength={10}
        value={mobile}
        onChange={(e) => setMobile(e.target.value.replace(/\D/g, "").slice(0, 10))}
        placeholder="10-digit mobile number"
        onKeyDown={(e) => e.key === "Enter" && proceed()}
      />
      <button style={m.primary} onClick={proceed}>Proceed</button>
      <button style={m.ghost} onClick={onClose}>Cancel</button>
    </Modal>
  );
}
